import { render, staticRenderFns } from "./FPFEmail.vue?vue&type=template&id=17851b06&scoped=true"
import script from "./FPFEmail.vue?vue&type=script&lang=js"
export * from "./FPFEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17851b06",
  null
  
)

export default component.exports